import { useCookieConsent } from '../hooks/useCookieConsent';

export const CookieConsentProvider = () => {
  useCookieConsent();
  return null;
};
